<template>
	<page>
		<module>
			<view-list ref="view" :work-type="workType" dynamic-field :field-sort="false" :view-config="auth('b_defect_summary_viewmanage')">
				<template #search>
					<m-search ref="search" :default-data="defaultSearchData">
						<m-search-item label="工序">
							<c-select name="process_ids" async multiple @search="searchProcess" ></c-select>
						</m-search-item>

                        <m-search-item label="产品">
                            <c-select name="product_ids" async multiple @search="searchProduct" ></c-select>
                        </m-search-item>

                        <m-search-item label="生产人员">
                            <c-select name="output_user_ids" async multiple @search="searchSysUser" ></c-select>
                        </m-search-item>

						<m-search-item label="工单">
							<c-select name="work_ids" async multiple @search="searchWork" ></c-select>
						</m-search-item>

						<m-search-item label="质检人员">
							<c-select name="test_user_ids" async multiple @search="searchSysUser" ></c-select>
						</m-search-item>

                        <m-search-item label="报工时间维度字段">
                            <c-select name="date_field" :options="dateFieldOptions" :clear="false"></c-select>
                        </m-search-item>
                        <m-search-item label="报工时间">
                            <c-datetime type="date" :range="freeEdition ? {limit: 30} : true" start-name="start_date" end-name="end_date" :clear="false"></c-datetime>
                        </m-search-item>

						<m-search-item label="质检时间">
							<c-datetime type="date" :range="freeEdition ? {limit: 30} : true" start-name="test_start_date" end-name="test_end_date" :clear="false"></c-datetime>
						</m-search-item>
						<m-search-item label="统计维度">
							<c-select name="dimension_id" :options="dimensionOption.active" :disable-options="dimensionOption.disabled" :clear="false">
								<template #option="{data, selected, disabled}">
									<select-option
										:name="data.name"
										:selected="selected"
										:vip="disabled"
									></select-option>
								</template>
							</c-select>
						</m-search-item>
					</m-search>
				</template>

				<template #operate>
					<c-button v-if="auth('b_defect_summary_export')" v-lock="lock('b_defect_summary_export')" prepend-icon="tf-export" @click="$refs.view.exportReportByViewId()">导出</c-button>
				</template>
			</view-list>
		</module>
	</page>
</template>

<script>
	import {mapState, mapGetters} from 'vuex'

	export default {
		data() {
			let now = new Date();
			return {
                workType:80,                    //质检数据报表
                defaultSearchData: {
					dimension_id: 132,          //默认维度【工序】
					date_field: 'create_date',
					start_date: new Date(now.getFullYear(), now.getMonth(), now.getDate()-30).format('yyyy-MM-dd'),
					end_date: new Date().format('yyyy-MM-dd')
				}
			}
		},

		computed: {
			...mapState(['auditStateDic', 'dateFieldOptions']),
			...mapGetters(['freeEdition']),

			dimensionOption() {
				let options = [{
                    name: '产品',
                    value: 131
                },{
                    name: '工序',
                    value: 132
                },{
                    name: '生产人员',
                    value: 133
                },{
					name: '生产人员+工序',
					value: 134
				},{
                    name: '生产人员+产品',
                    value: 135
                },{
                    name: '生产人员+产品+工序',
                    value: 136
                }];

				return {
					active: options,
					disabled: this.freeEdition ? options.filter(item => item.name.includes('+')).map(item => item.value) : []
				}
			}
		},

		methods: {
			/*******搜索【工序】下拉框信息*****************/
			searchProcess(keyword, resolve){
				this.request({
					url:'/system/options',
					data: {
						options_code:'DICPROCESS_SEARCH',
						keyword:keyword
					},
					success:data => {
						resolve(data);
					}
				})
			},
            /*******搜索【产品】下拉框信息*****************/
            searchProduct(keyword, resolve){
                this.request({
                    url:'/system/options',
                    data: {
                        options_code:'SELF_PRODUCT',
                        keyword:keyword
                    },
                    success:data => {
                        resolve(data);
                    }
                })
            },
			/*******搜索【员工】下拉框信息*****************/
			searchSysUser(keyword, resolve){
				this.request({
					url:'/system/options',
					data: {
						options_code:'SYSUSER',
						keyword:keyword
					},
					success:data => {
						resolve(data);
					}
				})
			},
            /*******搜索【工单】下拉框信息*****************/
            searchWork(keyword, resolve){
                this.request({
                    url:'/work/optionList',
                    data: {
                        keyword:keyword,
                        work_states: [1, 2]
                    },
                    success:data => {
                        var option = data.map(item => {
                            return {
                                name: item.work_code,
                                value: item.id,
                                data: item
                            }
                        });
                        resolve(option);
                    }
                })
            }
		}
	}
</script>

<style lang="stylus" scoped>
</style>